<template>
  <el-dialog
      v-dialogDrag
      title="修改用户信息"
      :visible="visible"
      width="60%"
      @close="close"
      @open="open"
      :close-on-click-modal="false"
  >
    <el-form
        v-loading="loading"
        element-loading-text="请稍候..."
        label-width="100px"
        class="operation"
        :model="editForm"
        ref="editForm"
    >
      <el-row>
        <el-col :xs="8" :sm="12">
          <el-form-item label="用户名" prop="account">
            <el-input
                type="text"
                size="medium"
                v-model="editForm.account"
                :disabled="true"
            />
          </el-form-item>
        </el-col>

        <el-col :xs="8" :sm="12">
          <el-form-item label="姓名" prop="name">
            <el-input
                type="text"
                size="medium"
                v-model="editForm.name"
            />
          </el-form-item>
        </el-col>

        <el-col :xs="8" :sm="12">
          <el-form-item label="电话" prop="mobile">
            <el-input
                type="text"
                size="medium"
                v-model="editForm.mobile"
            />
          </el-form-item>
        </el-col>

        <el-col :xs="8" :sm="12">
          <el-form-item label="邮箱" prop="email">
            <el-input
                type="text"
                size="medium"
                v-model="editForm.email"
            />
          </el-form-item>
        </el-col>
        <el-col :xs="8" :sm="12">
          <el-form-item label="所属部门"  required>
            <el-select v-model="editForm.orgId" clearable filterable placeholder="请选择所属部门" size="medium">
              <el-option
                  v-for="item in college"
                  :key="item.value"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="8" :sm="12">
          <el-form-item label="备注" prop="remark">
            <el-input
                type="text"
                size="medium"
                v-model="editForm.remark"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item label="角色">
          <el-select v-model="userRoles" multiple placeholder="请选择">
            <el-option
                    v-for="item in roleList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-row>
      <el-row>
        <el-col :xs="24" :sm="22" class="text-right">
          <el-button size="medium" @click="close" type="default"
          >取消
          </el-button
          >
          <el-button
                  size="medium"
                  @click="submitEditForm('form')"
                  type="primary"
          >保存
          </el-button>
        </el-col>
      </el-row>
    </el-form>
  </el-dialog>
</template>

<script>
import dialog from "@/components/mixins/dialog";
import {editUser} from "./api/index";
import request from '@/utils/apiRequest'
import {findSysRole,delSysroleInfo,addSysRoleInfo} from "@/views/serviceapp/systemManage/roleManage/api/index"
import {selectOrg} from "../../businessManage/personManage/personInfo/api";

export default {
  mixins: [dialog],
  props: {
    editForm: {type: Object | null, required: true, default: null},
  },
  data() {
    return {
      roleList: [],
      college:[],
      // 用户当前绑定的角色清单
      userRoles: []
    };
  },
  mounted() {
    this.selectOrg()
    this.fetchAllRoleList()
  },
  methods: {
    selectOrg(){
      selectOrg()
          .then((res) =>{
            this.college = res.data.data
          })
    },
    // 查询用户绑定的角色列表
    fetchUserRoles() {
      request({
        url: '/user/SysRole/listUserRoles',
        params: {
          userAccount: this.editForm.account
        }
      }).then(res => {
        this.userRoles = []
        res.data.forEach(role => this.userRoles.push(role.id))
      })
    },
    setUserRoles() {
      request({
        url: '/user/SysRole/setUserRoles',
        params: {
          userAccount: this.editForm.account,
          roleIds: this.userRoles.join(",")
        }
      }).then(res => {
      })
    },
    fetchAllRoleList() {
      let data = new FormData();
      data.append("current", 1);
      data.append("size", 9999);
      findSysRole(data)
          .then((res) => {
            this.roleList = res.data.data.records;
          })
          .catch((err) => {
            this.loading = false;
            this.$alert("服务器发生错误，请联系系统管理员", "登录失败", {
              type: "error",
            })
          });
    },
    submitEditForm() {
      // 设置角色
      this.setUserRoles()
      // 保存用户信息
      let data = Object.assign({}, this.editForm);
      data.chName = this.editForm.chName;
      data.url = this.editForm.url;
      data.type = this.editForm.type;
      data.enabled = this.editForm.enabled;
      data.parentId = this.editForm.parentId;
      data.remark = this.editForm.remark;
      editUser(data)
          .then((res) => {
            if (res.data.code == 20000) {
              this.$emit("success");
            } else {
              this.$message.error(res.data.message);
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$alert("服务器发生错误，请联系系统管理员", "登录失败", {
              type: "error",
            });
          });
    },
    open(name = "form") {
      //打开对话框先清除上次残留数据
      if (this.$refs[name]) {
        this.$refs[name].resetFields();
        this.$refs.editor.initValue("");
      }
      this.fetchUserRoles()
    },
  },
};
</script>
<style scoped>
.text-right {
  text-align: right;
}
</style>


